<template>
  <div>
    <v-text-field
      v-model="form.title"
      label="Tytuł lekcji"
      name="title"
      type="text"
      :error-messages="titleErrors"
      @input="onInput"
      @blur="$v.form.title.$touch()"
    />
    <!-- TODO: hidden for future (#35)
    <v-select
      :items="displayTypes"
      label="Sposób wyświetlania"
      v-model="form.displayType"
      @input="onInput"
      @blur="$v.form.displayType.$touch()"
      :error-messages="displayTypeErrors"
    />-->
    <v-slider
      v-if="hasAnyTest"
      v-model="form.passLevel"
      :label="`Procent punktów zapewniający zaliczenie lekcji (${form.passLevel}%)`"
      thumb-label
      step="1"
      :min="0"
      :max="100"
      hide-details
      @input="onInput"
    />
    <v-checkbox v-if="hasAnyTest" :input-value="true" disabled label="Wymagana do zaliczenia" />
    <v-checkbox v-else v-model="form.isRequired" label="Wymagana do zaliczenia" @change="onInput" />
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';

export default {
  mixins: [validationMixin],
  props: {
    lesson: {
      type: Object,
      required: true
    },
    definition: {
      type: Object,
      required: true
    },
    hasAnyTest: {
      type: Boolean,
      required: true
    }
  },
  data: function() {
    return {
      form: {
        title: this.definition.name,
        displayType: this.definition.displayType,
        passLevel: this.definition.passLevel === null ? 100 : this.definition.passLevel,
        isRequired: this.definition.isRequired
      } /*,
      displayTypes: [
        { text: 'Pełen ekran', value: 0 },
        { text: 'Okienko', value: 1 }
      ]*/
    };
  },
  validations: {
    form: {
      title: {
        required
      } /*,
      displayType: {
        required
      }*/
    }
  },
  computed: {
    titleErrors() {
      const errors = [];
      if (!this.$v.form.title.$dirty) {
        return errors;
      }
      if (!this.$v.form.title.required) {
        errors.push('Tytuł lekcji jest wymagany');
      }
      return errors;
    },
    /*displayTypeErrors() {
      const errors = [];
      if (!this.$v.form.displayType.$dirty) {
        return errors;
      }
      if (!this.$v.form.displayType.required) {
        errors.push('Sposób wyświetlania jest wymagany');
      }
      return errors;
    },*/
    formValid() {
      return !this.$v.form.$invalid && !this.$v.form.$pending;
    }
  },
  methods: {
    onInput() {
      this.$v.form.title.$touch();
      this.$emit('bodyChange', {
        valid: this.formValid,
        name: this.form.title,
        /*displayType: this.form.displayType,*/
        passLevel: this.hasAnyTest ? this.form.passLevel : null,
        isRequired: this.form.isRequired
      });
    }
  }
};
</script>
